import { makeStyles } from '@material-ui/core/styles';
import typography from '@/theme/typography';
import {
  PrimaryColors,
  SecondaryColors,
  SurfaceColors,
  TextColors,
  TextOpacities,
} from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const lightTheme = {
  root: {
    color: TextColors.dark,

    '&:not($inline)': {
      backgroundColor: SurfaceColors.light,
    },

    '& table a': {
      color: SecondaryColors.dark,
    },

    '& tr:not(:first-child)': {
      borderBottom: `1px solid ${hexToRGBA(TextColors.dark, TextOpacities.light4)}`,
      color: `1px solid ${hexToRGBA(TextColors.dark, TextOpacities.light2)}`,
    },
  },
};

const darkTheme = {
  root: {
    color: TextColors.light,

    '&:not($inline)': {
      backgroundColor: PrimaryColors.light,
    },

    '& table a': {
      color: SecondaryColors.main,
    },

    '& tr:not(:first-child)': {
      borderBottom: `1px solid ${hexToRGBA(TextColors.light, TextOpacities.dark4)}`,
      color: `1px solid ${hexToRGBA(TextColors.light, TextOpacities.dark2)}`,
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.light-theme': lightTheme.root,
      '&.dark-theme': darkTheme.root,

      '&:not($inline)': {
        borderRadius: muiTheme.shape.borderRadius,
        padding: muiTheme.spacing(2, 3),
      },

      [muiTheme.breakpoints.up('md')]: {
        '&:not($inline)': {
          padding: muiTheme.spacing(6),
        },
      },

      '& caption': {
        ...typography.h6,
        marginBottom: muiTheme.spacing(3),
        textAlign: 'left',
      },

      '& table, tr, td ': {
        border: 'none',
      },
      '& table': {
        borderCollapse: 'collapse',

        '& a': {
          textDecoration: 'none',
        },
      },
      '& td': {
        padding: muiTheme.spacing(0.5, 1, 0.5),

        '&:first-child': {
          paddingLeft: muiTheme.spacing(0.5),
        },

        '&:last-child': {
          paddingRight: muiTheme.spacing(0.5),
        },
      },
      '& tr:first-child': {
        ...typography.subtitle2,
      },
      '& tr:not(:first-child)': {
        ...typography.body2,
      },
    },
    text: {
      '&.MuiTypography-root': {
        marginBottom: muiTheme.spacing(4),
      },
    },
    container: {
      overflowX: 'auto',
      width: '100%',

      [muiTheme.breakpoints.down('md')]: {
        paddingBottom: muiTheme.spacing(1),
      },
    },
    inline: {},
  }),
  { name: 'GenTable' },
);

export default useStyles;
